import { createSlice } from '@reduxjs/toolkit';

import { MonitoringSystem } from 'entities/MonitoringSystem';
import { AppError } from 'entities/Errors';

import { getMonitoringSystemList } from './monitoring_system.action';

interface MonitoringSystemState {
  loading: boolean;
  error: null | AppError;
  list: MonitoringSystem[];
}

const initialState = {
  loading: false,
  error: null,
  list: [],
} as MonitoringSystemState;

export const MonitoringSystemSlice = createSlice({
  name: 'monitoringSystem',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getMonitoringSystemList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.list = [];
      })
      .addCase(getMonitoringSystemList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
      })
      .addCase(getMonitoringSystemList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default MonitoringSystemSlice.reducer;
